<template>
  <div>
    <collapsible-section
      :collapsible="true"
      :is-sub-section="true"
      class="sub-section"
      v-for="(product, i) in items.infoTable" :key="i"
    >
      <template #headerText>
        <h5>{{ product.category }}</h5>
      </template>
      <template #collapsibleSection>
        <div container>
          <table class="member-benefits">
            <thead>
            <th>Vision Care Services</th>
            <th>In-Network Member Cost</th>
            <th>Out-of-Network Reimbursement</th>
            </thead>

            <tbody v-for="(content, i) in product.content">
            <tr>
              <td>
                <strong>{{ content.name }}</strong>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr v-for="(benefit, b) in content.benefit" :key="b" class='nested' v-if="benefit">
              <td>
                <p v-if="benefit.name">{{ benefit.name }}</p>
              </td>
              <td>
                <p v-if="benefit.inn">{{ benefit.inn }}</p>
              </td>
              <td>
                <p v-if="benefit.oon">{{ benefit.oon }}</p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
    </collapsible-section>
  </div>
</template>

<script>
  import CollapsibleSection from '@sections/CollapsibleSection'

  export default {
    props: {
      items: Object,
      theme: {
        type: String,
        required: false,
        default: 'leaf'
      }
    },
    components: {
      CollapsibleSection
    }
  }
</script>

<style lang="scss" scoped>

</style>
